import React, {FunctionComponent, useState} from 'react';
import {Page} from 'b302-frontend-library';
import {useParams} from 'react-router-dom';
import {useQuery, UseQueryResult} from '@tanstack/react-query';

import {
    UniversityParts,
    useUniversityCostsQueryConfig,
    useUniversityPartsQueryConfig,
    useUniversitySubjectsQueryConfig
} from '../../../../query/University/Query';
import University from '../../../../../networking/models/University';
import UniversityDetailContent from './UniversityDetailContent';
import {UniversitySubjectsResponse} from '../../../../../networking/responses/University';

const UniversityDetail: FunctionComponent = () => {
    const { id } = useParams();
    const universityId = Number(id);

    const [params, setParams] = useState({});

    const [universityPartsConfig] = useUniversityPartsQueryConfig(universityId);
    const [universityCostsConfig] = useUniversityCostsQueryConfig(universityId);
    const [universitySubjectsConfig, setPage] = useUniversitySubjectsQueryConfig(universityId, params);

    const query: [
        UseQueryResult<UniversityParts>,
        UseQueryResult<University>,
        UseQueryResult<UniversitySubjectsResponse>
    ] = [
        useQuery(universityPartsConfig),
        useQuery(universityCostsConfig),
        useQuery(universitySubjectsConfig)
    ];

    return (
        <Page className={'university-detail'}>
            { query.every(q => q.data) &&
                <UniversityDetailContent
                    university={query[1].data!}
                    parts={query[0].data!}
                    universityWithCosts={query[1].data!}
                    subjects={query[2].data!}
                    filters={params}
                    setFilters={setParams}
                    onSubjectPageChange={setPage} />
            }
        </Page>
    );
};

export default UniversityDetail;
